import React from "react";

export default function AuthIndex() {
  return (<React.Fragment />);
}


// import Formsy from "formsy-react";
// import {compose} from "recompose";

// import Grid from "../components/bootstrap/grid";
// import Row from "../components/bootstrap/row";
// import Col from "../components/bootstrap/col";
// import SectionPanel from "../common/section-panel";
// import FormsyTextInput from "../components/formsy/text-field";
// import FormsyCheckbox from "../components/formsy/checkbox";
// import Button from "../components/bootstrap/button";

// import {PageHOC} from "../../logic/page";
// import {login, loginResult} from "../../logic/user";
// import {withRouter} from "react-router-dom";
// import Dialog from "../components/bootstrap/dialog";
// import { withTranslation } from "react-i18next";
// import AlertBanner from "../components/bootstrap/alert-banner";


// class AuthIndex extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       userName: "",
//       password: "",
//       showTerms: false,
//       showPrivacy: false,
//     };
//   }
//   render() {
//     const {page, t} = this.props;
//     let prompt;
//     if (this.state.error) {
//       prompt = (<AlertBanner message={t("resource.site.auth.general.invalidUsernamePassword")} alertType={"danger"} />);
//     } else if (this.state.accepttnc) {
//       prompt = (<AlertBanner message={t("resource.site.auth.general.termsPrivacy")} alertType={"warning"} />);
//     } else {
//       prompt = undefined;
//     }
//     return (<React.Fragment>
//       {this.state.showPrivacy ? (<Dialog title={t("resource.register.register.privacyPolicy")} onRequestClose={() => {
//         return this.setState({
//           showPrivacy: false,
//         });
//       }}>
//         <div style={{textAlign: "left"}} dangerouslySetInnerHTML={{__html: page.values.privacy}} />
//       </Dialog>) : undefined}
//       {this.state.showTerms ? (<Dialog title={t("resource.site.auth.general.termsAndConditions")} onRequestClose={() => {
//         return this.setState({
//           showTerms: false,
//         });
//       }}>
//         <div style={{textAlign: "left"}} dangerouslySetInnerHTML={{__html: page.values.terms}} />
//       </Dialog>) : undefined}
//       {/* <form ref={(r) => (this.frmLogin = r)} name="login" action="https://mow.auth.vostro.app/login" method="post">
//         <input type="hidden" name="radius11" value="hotspot"/>
//         <input type="hidden" name="dst" value="https://www.google.com"/>
//         <input type="hidden" name="username" value={this.state.password}/>
//         <input type="hidden" name="password" value={this.state.userName}/>
//       </form> */}
//       <Grid>
//         <Row>
//           <Col xs={"auto"} className="mx-auto">
//             <Formsy className="frm-login" onValidSubmit={async(model) => {
//               try {
//                 if (!model.accepttnc) {
//                   return this.setState({
//                     error: false,
//                     accepttnc: true,
//                   });
//                 }
//                 return this.setState({
//                   error: false,
//                   accepttnc: false,
//                 }, async () => {
//                   try {
//                     const results = await this.props.loginMutation({
//                       variables: {
//                         username: model.userName,
//                         password: model.password,
//                       },
//                     });
//                     const loginData = loginResult(results);
//                     if (loginData) {
//                       return this.setState({
//                         userName: model.userName,
//                         password: model.password,
//                       }, () => {
//                         switch (loginData.type) {
//                           case "admin":
//                             window.location = "/";
//                             break;
//                           case "user":
//                             window.location = "https://www.google.com";
//                             break;
//                         }
//                       });
//                     }
//                   } catch (err) {
//                     console.log("err", err);
//                   }
//                   return this.setState({
//                     error: true,
//                   });
//                 });
//                 // window.location = "/";
//               } catch (err) {
//                 console.log(err); // eslint-disable-line
//               }
//               return undefined;
//             }}>
//               {prompt}
//               <Grid fluid className="form-spacer login-form">
//                 <Row>
//                   <Col className="username-field">
//                     <FormsyTextInput required name="userName" placeholder={t("general.user.username")} />
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col className="password-field">
//                     <FormsyTextInput required name="password" placeholder={t("general.details.password")} type="password"/>
//                   </Col>
//                 </Row>

//                 <Row className="align-items-center accepttncs">
//                   <Col xs="auto">
//                     <FormsyCheckbox name="accepttnc" />
//                   </Col>
//                   <Col>
//                     {t("resource.site.auth.general.iAgreeToTheFull")}
//                     <a href="#" onClick={() => this.setState({showTerms: true})}>{t("resource.register.register.termsOfService")}</a>
//                     {` ${t("resource.register.register.and")} `}
//                     <a href="#" onClick={() => this.setState({showPrivacy: true})}>{t("resource.register.register.privacyPolicy")}</a>
//                   </Col>
//                 </Row>
//                 <Row style={{marginTop: 20}}>
//                   <Col xs={12}>
//                     <Button style={{width: "100%"}} colour="primary">{t("resource.site.auth.general.Login")}</Button>
//                   </Col>
//                 </Row>
//               </Grid>
//             </Formsy>
//           </Col>
//         </Row>
//       </Grid>
//     </React.Fragment>);
//   }
// }
// export default compose(PageHOC, login, withRouter, withTranslation())(AuthIndex);

